import HomeIcon from "@mui/icons-material/Home";
import { Box, IconButton, Typography, useColorScheme } from "@mui/joy";
import { onValue, ref, runTransaction } from "firebase/database";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { database } from "../../utils/firebase";

const HatchlingReaderHeader = () => {
  const { mode } = useColorScheme();
  const isDark = mode === "dark";
  const [viewCount, setViewCount] = useState<number | null>(null);

  // Ember color for Hatchling
  const emberColor = "rgba(239, 68, 68, 0.8)";

  useEffect(() => {
    // Get Firebase Database reference for Hatchling
    const viewsRef = ref(database, "hatchling-read-online");

    // Check if this is a unique visitor this month
    const visitStorageKey = "timelessaria_hatchling_visited";
    const currentMonth = `${new Date().getMonth()}_${new Date().getFullYear()}`;
    const previousVisit = localStorage.getItem(visitStorageKey);
    const isNewVisit = previousVisit !== currentMonth;

    // If this is a new visit this month, increment the count
    if (isNewVisit) {
      // Store current month in localStorage
      localStorage.setItem(visitStorageKey, currentMonth);

      // Increment the visitor count
      runTransaction(viewsRef, (currentValue) => {
        return (currentValue || 0) + 1;
      }).catch((error) => {
        console.error("Error incrementing read count:", error);
      });
    }

    // Listen for count updates
    const unsubscribe = onValue(
      viewsRef,
      (snapshot) => {
        setViewCount(snapshot.val() || 0);
      },
      (error) => {
        console.error("Firebase error:", error);
        setViewCount(0);
      }
    );

    // Clean up listener
    return () => unsubscribe();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        py: 3,
        mb: 2,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <IconButton
            variant="soft"
            color="neutral"
            sx={{
              borderRadius: "50%",
            }}
          >
            <HomeIcon />
          </IconButton>
        </Link>
        <Box>
          <Typography
            level="h4"
            sx={{
              fontFamily: "'Cinzel', serif",
              color: emberColor,
              letterSpacing: "0.05em",
            }}
          >
            Hatchling of the Orchard
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography
              level="body-xs"
              sx={{
                color: isDark ? "neutral.400" : "neutral.600",
                fontStyle: "italic",
              }}
            >
              A Prelude to The Ember Tide
            </Typography>
            {viewCount !== null && (
              <Typography
                level="body-xs"
                sx={{
                  color: isDark ? "neutral.500" : "neutral.500",
                }}
              >
                • {viewCount} {viewCount === 1 ? "reader" : "readers"} to date
              </Typography>
            )}
          </Box>
        </Box>
      </Box>

      <Typography
        level="body-sm"
        sx={{
          color: isDark ? "neutral.500" : "neutral.500",
          fontFamily: "'Cinzel', serif",
        }}
      >
        Timeless' Aria
      </Typography>
    </Box>
  );
};

export default HatchlingReaderHeader;
